import { Typography } from '@mui/material';
import { countryList } from '../../ovComponents/resources';

export const CountryName = ({ code }: { code: string }) => (
    <Typography>
      {countryList.find((country) => country.code === code)?.name ?? code}
    </Typography>
);
